export default function SwitchOnePrivacyPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto", textAlign: "left" }}>
      <h1>Privacy Policy for Switch One</h1>

      <p>
        <strong>Last Updated:</strong> 07 July 2026
      </p>

      <p>
        Switch One respects your privacy. This Privacy Policy explains how we
        collect, use, and protect information when you use our mobile
        application ("App"). This application is intended exclusively for
        authorized employees of our organization.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>1.1 Employee Account Information</h3>
      <p>
        User accounts are created and managed by the organization. Employees
        cannot create accounts themselves. We may collect and maintain the
        following information:
      </p>

      <ul>
        <li>Employee Name</li>
        <li>Mobile Number</li>
        <li>Employee ID (if applicable)</li>
        <li>Department or Branch Information</li>
        <li>Login Credentials provided by the organization</li>
      </ul>

      <h3>1.2 Customer and Lead Information</h3>
      <p>
        The App allows employees to create and manage customer enquiries and
        leads. Information entered may include:
      </p>

      <ul>
        <li>Customer Name</li>
        <li>Mobile Number</li>
        <li>Email Address (if provided)</li>
        <li>Address or Location Details</li>
        <li>Enquiry Details</li>
        <li>Lead Status and Follow-up Information</li>
      </ul>

      <h2>2. How We Use Information</h2>

      <ul>
        <li>To provide employee access to the App</li>
        <li>To manage customer enquiries and leads</li>
        <li>To maintain customer relationship records</li>
        <li>To track sales and service activities</li>
        <li>To improve operational efficiency</li>
        <li>To ensure application security and performance</li>
      </ul>

      <h2>3. Permissions Used</h2>

      <h3>Phone Permission</h3>
      <p>
        The App may use phone functionality to directly call customers,
        prospects, or existing customers from within the application for
        business purposes.
      </p>

      <h3>Internet Access</h3>
      <p>
        Required for user authentication, synchronization of customer data,
        lead management, and communication with our servers.
      </p>

      <h2>4. Data Sharing</h2>

      <p>
        Customer and employee information is used solely for business
        operations. We do not sell, rent, or share personal information with
        third parties except where required by law or authorized by the
        organization.
      </p>

<h2>5. Data Security</h2>

<p>
  We take appropriate security measures to protect employee and customer
  information. The application includes security features such as PIN-based
  authentication and App Lock functionality to help prevent unauthorized access
  to the application and its data.
</p>



      <h2>6. Data Retention</h2>

      <p>
        Employee, customer, lead, and enquiry information may be retained as
        long as required for business operations, legal compliance, and record
        management purposes.
      </p>

      <h2>7. Employee Responsibilities</h2>

      <p>
        Employees must use customer information only for authorized business
        purposes and must not share, misuse, or disclose customer information
        without proper authorization.
      </p>

      <h2>8. Children's Privacy</h2>

      <p>
        This App is intended solely for use by authorized employees and is not
        designed for children under the age of 13.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted within the application with the updated effective date.
      </p>

      <h2>10. Contact Us</h2>

       <p>
        <strong>Email:</strong> itconnect@switchmobilityev.com
        <br />
        <strong>Developer/Company Name:</strong> Switch Mobility Ltd
      </p>
    </div>
  );
}